import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import Button from '@mui/material/Button';
import { IAgreementCodeFormValues } from '../../../../@types/model/masterData/agreementCode/agreementCodeFormValues';
import { PillButton, ControlledMuiAutoCompleteSelect } from '@zz2/zz2-ui';
import { useMasterDataOptions } from '../../../../hooks/useMasterDataOptions';
import AgreementCodeModelHelper from '../../../../@types/model/masterData/agreementCode/agreementCodeModelHelper';
import { yupResolver } from '@hookform/resolvers/yup';
import CustomReactHookFormDevTools from '../../../../components/devtools/ReactHookFormDevTools';

interface IAgreementCodeFormProps {
    isLoading : boolean;
    initialValues : IAgreementCodeFormValues;
    onSubmit : (values : IAgreementCodeFormValues) => void;
    onClose : () => void;
}

const AgreementCodeForm = (props : IAgreementCodeFormProps) : React.ReactElement => {

    const { handleSubmit, control, formState: { isValid, isDirty }, trigger } = useForm<IAgreementCodeFormValues>({
        defaultValues: props.initialValues,
        resolver: yupResolver(AgreementCodeModelHelper.formSchema()),
        mode: 'onChange',
    });

    /*================================================================================================================
     *                                                  Effects
     * ==============================================================================================================*/

    useEffect(() => {
        trigger();
    }, []);

    /*================================================================================================================
     *                                                  Async Methods
     * ==============================================================================================================*/

    /*================================================================================================================
     *                                                  Handler Methods
     * ==============================================================================================================*/

    /*================================================================================================================
     *                                                  Memos
     * ==============================================================================================================*/

    const marketOptions = useMasterDataOptions('market');

    /*================================================================================================================
     *                                                  Render Methods
     * ==============================================================================================================*/

    return (
        <div>
            <form onSubmit={handleSubmit(props.onSubmit)}>
                <div className={'fdc p20 pt15 pb0'}>
                    <ControlledMuiAutoCompleteSelect
                        className={'mb10'}
                        control={control}
                        label={'Target Market'}
                        defaultValues={props.initialValues.targetMarket ?? null}
                        options={marketOptions}
                        name={'targetMarket'}
                    />
                    <div className={'fdr flx1 aic jcfe'}>
                        <Button
                            className={'cpd mr20'}
                            type={'reset'}
                            onClick={props.onClose}
                        >
                            CANCEL
                        </Button>
                        <PillButton
                            className={'pl30 pr30'}
                            text={'SAVE'}
                            size={'small'}
                            type={'submit'}
                            color={'secondary'}
                            disabled={ !isDirty || !isValid || props.isLoading }/>
                    </div>
                </div>
            </form>
            <CustomReactHookFormDevTools control={control} />
        </div>
    );
};

export default AgreementCodeForm;
